import { IdPersistence } from "../constants/IdPersistence";
import { PersistenceMode } from "./PersistenceMode";
import { utilPersistence } from "./utilPersistence";
var UnsetVersion = "0.0.0";
var UtilVersion = /** @class */ (function () {
    function UtilVersion(id) {
        var _this = this;
        this.id = id;
        this.setBuildNumber = function (buildNumber) {
            var version = (process.env.REACT_APP_VERSION || UnsetVersion) + "." + buildNumber;
            _this.setVersion(version);
        };
        this.getCurrentVersion = function () { return _this.versionInfo.newVersion; };
        this.getPreviousVersion = function () { return _this.versionInfo.oldVersion; };
        this.setVersion = function (newVersion) {
            var oldVersion = newVersion !== _this.getPreviousVersion() ? _this.versionInfo.newVersion : newVersion;
            _this.versionInfo = {
                newVersion: newVersion,
                oldVersion: oldVersion,
            };
            utilPersistence.setValue(_this.id, _this.versionInfo, PersistenceMode.Update);
        };
        this.versionInfo = utilPersistence.getValue(id, {
            newVersion: UnsetVersion,
            oldVersion: UnsetVersion,
        });
    }
    return UtilVersion;
}());
export var utilVersion = new UtilVersion(IdPersistence.Version);



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilVersion.ts
// module id = 189
// module chunks = 3